// extracted by mini-css-extract-plugin
export default {"privacy":"privacypolicy_privacy__CApcE"};